import api from '../../../shared/services/api';
import { ProcessedTestsResponse } from '../types/pdf-processing.types';

interface GetProcessedTestsParams {
  page?: number;
  limit?: number;
  searchQuery?: string;
  statusFilter?: string;
  sortBy?: string;
}

export const TestProcessingService = {
  /**
   * Get paginated processed tests
   */
  async getProcessedTests({
    page = 1,
    limit = 10,
    searchQuery = '',
    statusFilter = '',
    sortBy = 'newest',
  }: GetProcessedTestsParams): Promise<ProcessedTestsResponse> {
    const { data } = await api.get<ProcessedTestsResponse>('/test-processing', {
      params: {
        page,
        limit,
        search: searchQuery,
        status: statusFilter,
        sort: sortBy,
      },
    });
    return data;
  },

  /**
   * Get PDF URL for a test
   */
  async getTestPdfUrl(testId: string): Promise<string> {
    const { data } = await api.get(`/tests/${testId}/pdf`);
    return data.pdfUrl;
  },
};
